export let EntityType = /*#__PURE__*/function (EntityType) {
  EntityType["USER"] = "USER";
  EntityType["TEAM"] = "TEAM";
  EntityType["GROUP"] = "GROUP";
  return EntityType;
}({});

// Override UserPickerProps below with replacement documentation